import React, { memo } from 'react'
import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons'

import FailedStatus from '../common/FailedStatus'
import customConfig from 'customConfig'

const CodeUsed = ({ onSubmit, t }) => (
  <FailedStatus
    title={t(customConfig.codeUsedLabel)}
    description={t(customConfig.rewardCodeUsedLabel)}
    icon={faExclamationCircle}
    onSubmit={onSubmit}
    t={t}
  />
)

export default memo(CodeUsed)
